<template>
  <div class="sd-table-group">
    <div class="sd-table-row" :key="ix"
    v-for="(result, ix) in ticketList">
      <div v-for="(column, ix) in tableParams" :key="ix"
        class="sd-row-item" :style="{
          'min-width': tableParams[ix].width,
          width: tableParams[ix].width,
        }"
        :class="{ clickable: tableParams[ix].clickable }">
        <a v-if="column.renderDate">
          {{ renderDate(renderField(result, column.fields)) }}
        </a>
        <a v-else-if="column.clickable" :href="renderHref(result.key)">
          {{ renderField(result, column.fields, column.defaultValue) }}
        </a>
        <a v-else :class="(column.sortKey === 'status')
          ? 'sd-status sd-' + result.fields.status.statusCategory.colorName
          : ''"
        >
          {{ renderField(result, column.fields, column.defaultValue) }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sd-jira-list',
  props: [
    'ticketList',
    'renderDate',
    'tableParams',
  ],

  computed: {
    routeKey() {
      if ('key' in this.$route.params) {
        return this.$route.params.key.toLowerCase();
      }
      return undefined;
    },
  },

  methods: {
    renderField(result, fields, defaultVal) {
      return fields.reduce((acc, part) => acc && acc[part], result)
        || defaultVal;
    },

    renderHref(key) {
      return `/${this.routeKey}/issue/${key}/`
    },
  },
};
</script>



// WEBPACK FOOTER //
// JiraList.vue?0b24cf3e